import { createFileRoute } from '@tanstack/react-router'

import AuditLog from '@/components/AuditLog/AuditLog.tsx'
import { withStaticTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/audit')({
  component: () => <AuditLog />,
  head: withStaticTitle('Audit Log'),
})
